import React, { useEffect } from 'react'
import { Men } from './menu.styled'
import { getRequest } from '../http'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import {Link, Outlet} from 'react-router-dom'
import { Helmet } from 'react-helmet'


export default function Menu() {

  const [items, setItems] = useState([])
  const [images, setImages] = useState([])
  const [load, setLoad] = useState(false)


  
  document.querySelector('title').innerText = 'Menu | Beehive Cafe' 

  

  const onType = (e)=>{
    setLoad(true)
    const type = e.target.value
    
    getRequest(`/items/62f6dbb24cf7aa45e8d753c0/${type}`,(resp)=>{
      setItems(resp.data.results)
    }).finally(()=>{
      setTimeout(() => {
        setLoad(false)
      }, 1000);
      
    })
  }
  const Details = (item)=>{
    localStorage.setItem('item',JSON.stringify( item))
  }
  useEffect(()=>{
    const loader = document.querySelector('.loading')
    getRequest(`/get_item/62f6dbb24cf7aa45e8d753c0/user`, (resp)=>{
      
      setImages(resp.data.results)
    }).finally(()=>{
      loader.style.display = 'none'
    })
    return ()=>{
      loader.style.display = 'block'
    }
  },[])
  return (
    <div>
      <Helmet>
        <title>Menu</title>
      <meta name="description" content="Calamari, squid heads & 4 King prawns, served with fresh-cut chips 
& rice" />
      <meta property="og:type" content="article"/>
      <meta property="og:title" content="CALAMARI & KING PRAWN PLATTER"/>
      <meta property="og:site_name" content="beehive-cafe"/>
      <meta property="og:url" content="https://beehive-cafe.web.app"/>
      <meta property="og:locale" content="en_US"/>
      <meta property="og:image" content= "https://firebasestorage.googleapis.com/v0/b/coral-circlet-331006.appspot.com/o/images%2F129f27b3-0e9f-4149-8c8d-c539d14c5de8?alt=media&token=f0d7aa39-eb97-4812-9f96-b6e5ae1d03b3"/>
      </Helmet>
      <Outlet/>
      <Men>
        
        <div className="menus-wrap">
          <div className="menus">
            
            {images?.map((image, i)=>{
              return <div key={i}>
                <label htmlFor={image.type}>
                  <h5>{image.type}</h5>
                  <img src={image.url} height={'80px'} alt="" />
                </label>
                <input onChange={onType} value={image.type} type="radio" name="type" id={image.type} />
              </div>
            })}
          </div>
        </div>
        <div className="items">
          <ul>
            <li style={{display: load ? 'contents' : 'none'}}><Spinner variant='success' animation='grow'/></li>
            {!load && items?.map((item, i)=>{
              return <li key={i}>
                <Link onFocus={()=>Details(item)} to='item'>
                <div className='_top'>
                <h6>{item?.name}</h6>
                <h6>R {item?.price}</h6>
                </div>
                <div>
                <img src={item?.image_url} height={'50px'} alt="" />
                <p>{item?.description}</p>
                </div>
                </Link>
              </li>
            })}
          </ul>
        </div>
      </Men>
    </div>
  )
}
